const ELEMENTS_IN_USE = {
    parent: '.js--parent-wrapper',
    opener: '.js--show-more-links',
    hiddenElements: '.js--hidden-link',
    hiddenElementsMobile: '.js--hidden-link-m',
    hiddenElementsDesktop: '.js--hidden-link-d',
    hideClassName: 'd-none',
};

const getHiddenClass = (wrapper) => {
    if (window && window.innerWidth > 1123) {
        return wrapper.querySelectorAll(ELEMENTS_IN_USE.hiddenElementsDesktop);
    }
    return wrapper.querySelectorAll(ELEMENTS_IN_USE.hiddenElementsMobile);
};

export default function showMoreLinks() {
    const openers = document.querySelectorAll(ELEMENTS_IN_USE.opener);

    if (!openers) { return false; }

    openers.forEach((element) => {
        const wrapper = element.closest(ELEMENTS_IN_USE.parent);
        const hiddenLinks = getHiddenClass(wrapper).length ? getHiddenClass(wrapper) : wrapper.querySelectorAll(ELEMENTS_IN_USE.hiddenElements);
        const wrapperHeight = wrapper.offsetHeight;

        hiddenLinks.forEach((link) => {
            link.classList.add(ELEMENTS_IN_USE.hideClassName);
        });

        const parentHeightCurrent = wrapper.offsetHeight;

        wrapper.style.maxHeight = `${parentHeightCurrent}px`;

        element.addEventListener('click', () => {
            // eslint-disable-next-line no-param-reassign
            element.style.display = 'none';
            hiddenLinks.forEach((item) => {
                item.classList.remove(ELEMENTS_IN_USE.hideClassName);
            });
            wrapper.style.maxHeight = `${wrapperHeight}px`;
        });
    });
}
